<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d7e2128"><span>contents</span></p>
<p class="cct" id="d7e2178"><span><a href="#/Text/Morg_9781550924589_epub_c6_r1#d7e32410" id="d14e147">Acknowledgments</a></span></p>
<p class="cct" id="d7e2228"><span><a href="#/Text/Morg_9781550924589_epub_c7_r1#d7e38012" id="d14e150">Preface to the New Edition</a></span></p>
<p class="cct" id="d7e2278"><span><a href="#/Text/Morg_9781550924589_epub_c8_r1#d7e76416" id="d14e153">Introduction to the 1990 Edition</a><br/>
<br/></span></p>
<p class="cct" id="d7e2328"><span class="sgc-1">PART I : Ingredients</span></p>
<p class="cct" id="d7e2388"><span><a href="#/Text/Morg_9781550924589_epub_c9_r1#d7e139422" id="d14e161">Produce List</a></span></p>
<p class="cct" id="d7e2438"><span><span href="#/Text/Morg_9781550924589_epub_c29_r1#d7e575163" id="d14e164" title="Link target outside of Sample">Other Ingredients Common to These Recipes</span></span></p>
<p class="cct" id="d7e2488"><span><span href="#/Text/Morg_9781550924589_epub_c30.1_r1#d7e644969" id="d14e167" title="Link target outside of Sample">A Note on Urban Compost</span></span></p>
<p class="cct" id="d7e2538"><span><span href="#/Text/Morg_9781550924589_epub_c30.2_r1#d7e671271" id="d14e170" title="Link target outside of Sample">Gluten-free Recipes</span><br/>
<br/></span></p>
<p class="cct" id="d7e2588"><span class="sgc-1">PART II : Recipes</span></p>
<p class="cct" id="d7e2638"><span><span href="#/Text/Morg_9781550924589_epub_c31_r1#d7e676272" id="d14e178" title="Link target outside of Sample">Soups</span></span></p>
<p class="cct" id="d7e2698"><span><span href="#/Text/Morg_9781550924589_epub_c59_r1#d7e10128100" id="d14e182" title="Link target outside of Sample">Salads</span></span></p>
<p class="cct" id="d7e2748"><span><span href="#/Text/Morg_9781550924589_epub_c79_r1#d7e12277122" id="d14e185" title="Link target outside of Sample">Main Dishes</span></span></p>
<p class="cct" id="d7e2798"><span><span href="#/Text/Morg_9781550924589_epub_c129_r1#d7e19187174" id="d14e188" title="Link target outside of Sample">Side Dishes</span></span></p>
<p class="cct" id="d7e2848"><span><span href="#/Text/Morg_9781550924589_epub_c203_r1#d7e27096248" id="d14e191" title="Link target outside of Sample">Sauces</span></span></p>
<p class="cct" id="d7e2898"><span><span href="#/Text/Morg_9781550924589_epub_c213_r1#d7e28087258" id="d14e194" title="Link target outside of Sample">Desserts &amp; Baked Goods</span><br/>
<br/></span></p>
<p class="cct" id="d7e2948"><span class="sgc-1">PART III: Ideas and Resources</span></p>
<p class="cct" id="d7e3008"><span><span href="#/Text/Morg_9781550924589_epub_c246_r1#d7e32213292" id="d14e202" title="Link target outside of Sample">Menus</span></span></p>
<p class="cct" id="d7e3058"><span><span href="#/Text/Morg_9781550924589_epub_c252_r1#d7e32664298" id="d14e205" title="Link target outside of Sample">Resources</span></span></p>
<p class="cct" id="d7e3158"><span><span href="#/Text/Morg_9781550924589_epub_c256_r1#d7e33701320" id="d14e208" title="Link target outside of Sample">About the Author</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Morg_9781550924589_epub_c5_r1.vue?34a0e9c8